<script setup lang="ts">
const props = defineProps({
  state: {
    type: null,
    required: true
  }
})

function closePreview () {
  location.href = `?preview=false${location.hash}`
}
</script>

<template>
  <v-footer color="grey-lighten-4">
    <div class="d-flex w-100 justify-space-between">
      <v-btn
        density="compact"
        variant="plain"
        @click="closePreview"
      >
        Close preview
      </v-btn>
      <div>
        <span>
          <strong>Vue:</strong>
          <span>{{ props.state.vueVersion.value }}</span>
        </span>
        &nbsp;
        <span>
          <strong>Vuetify:</strong>
          <span>{{ props.state.vuetifyVersion.value }}</span>
        </span>
      </div>
    </div>
  </v-footer>
</template>
